"use client";
import React from "react";
import { usePathname } from "next/navigation";
import PropTypes from "prop-types";

const NavBar = ({ menuItems }) => {
  const pathname = usePathname();
  const currentPath = pathname;

  const isActive = (path, alternativePaths = []) => {
    return currentPath === path || alternativePaths.includes(currentPath);
  };

  return (
    <div className="navbar bg-base-100 shadow-sm border-b border-gray-200">
      <div className="navbar-start">
        <div className="dropdown">
          <div tabIndex={0} role="button" className="btn btn-ghost lg:hidden">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"></path>
            </svg>
          </div>
          <ul
            tabIndex={0}
            className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
            {menuItems.map((item, index) => (
              <li key={index}>
                <a
                  href={item.path}
                  className={
                    isActive(item.path, item.alternativePaths) ? "active" : ""
                  }>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <a href="/" className="btn btn-ghost">
          <img
            src="/logo.webp"
            alt="Logo"
            className="w-14 h-12"
            height={100}
            width={120}
          />
        </a>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal px-1">
          {menuItems.map((item, index) => (
            <li key={index}>
              <a
                href={item.path}
                className={
                  isActive(item.path, item.alternativePaths) ? "active" : ""
                }>
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="navbar-end">
        {/* Espace pour d'éventuels boutons futurs */}
      </div>
    </div>
  );
};

NavBar.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      alternativePaths: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
};

export default NavBar;
